<template>
  <div>
    <div style="background:linear-gradient(90deg,#4f5bd5,#5f2c82);color:#fff;padding:24px 16px 12px 16px;border-radius:8px;margin-bottom:20px;font-size:18px;">
      欢迎来到墅梯智选展厅管理后台！<br>
      您可以在此管理展厅数据，支持地图选点、数据维护等功能。
    </div>
    <el-button type="primary" @click="openForm()" style="margin-bottom:16px">新增展厅</el-button>
    <div v-if="loading" style="text-align:center;padding:40px 0;color:#888;">
      正在加载数据，请稍候...
    </div>
    <div v-else-if="error" style="text-align:center;padding:40px 0;color:#e74c3c;">
      数据加载失败，请检查网络或稍后重试。
      <el-button type="text" @click="getList">重试</el-button>
    </div>
    <el-table v-else-if="list.length > 0" :data="list" style="width: 100%">
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="address" label="地址" />
      <el-table-column prop="phone" label="电话" />
      <el-table-column label="品牌" width="120">
        <template #default="scope">
          <div v-if="scope.row.brand_name" style="display: flex; align-items: center;">
            <img v-if="scope.row.brand_icon" :src="scope.row.brand_icon" style="width: 20px; height: 20px; margin-right: 8px; object-fit: contain;" />
            <span>{{ scope.row.brand_name }}</span>
          </div>
          <span v-else style="color: #999;">未设置</span>
        </template>
      </el-table-column>
      <el-table-column prop="tags" label="标签" />
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button size="mini" @click="openForm(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="onDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-else style="text-align:center;padding:40px 0;color:#888;">
      暂无展厅数据，请点击“新增展厅”按钮添加。
    </div>
    <showroom-form :visible.sync="formVisible" :data="formData" @refresh="getList" />
  </div>
</template>

<script>
import axios from 'axios';
import ShowroomForm from './ShowroomForm.vue';
export default {
  name: 'ShowroomList',
  components: { ShowroomForm },
  data() {
    return {
      list: [],
      loading: false,
      error: false,
      formVisible: false,
      formData: null
    };
  },
  created() {
    this.getList();
  },
  methods: {
    async getList() {
      this.loading = true;
      this.error = false;
      try {
        const res = await axios.get('/api/admin/showroom', { headers: { Authorization: localStorage.getItem('token') } });
        this.list = res.data.data || [];
      } catch (e) {
        this.error = true;
        this.list = [];
      } finally {
        this.loading = false;
      }
    },
    openForm(row) {
      this.formData = row ? { ...row } : null;
      this.formVisible = true;
    },
    async onDelete(row) {
      this.$confirm('确定删除该展厅吗？', '提示', { type: 'warning' })
        .then(async () => {
          await axios.delete(`/api/admin/showroom/${row.id}`, { headers: { Authorization: localStorage.getItem('token') } });
          this.$message.success('删除成功');
          this.getList();
        });
    }
  }
};
</script>